import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/backoffice/face_detection_projects';

class FaceDetectionLister extends ServiceBase {
  constructor() {
    super({ resource });
  }

  getListProjects = (params) => {
    const resourceProjects = 'face_detection_projects/';
    const response = this.http.get(resourceProjects, params);
    return response;
  };

  getListAccesses = (params) => {
    const resourceListAccess = 'face_detection_projects/list_access/';
    const response = this.http.get(resourceListAccess, { params });
    return response;
  }
}

export default FaceDetectionLister;



// WEBPACK FOOTER //
// ./src/services/FaceDetectionService.js